// ISSUE WITH GALLERY VIDEO NOT PLAYING ON SOME MOBILE DEVICES (works with thumbnails and swipe)
document.addEventListener('DOMContentLoaded', function() {
  var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  if (isMobile) {
    function playVideoInActiveSlide() {
      // Find the active slide
      var activeSlide = document.querySelector('.product .product__media-item.swiper-slide-active');
      if (activeSlide) {
        // Find the video element within the active slide
        var video = activeSlide.querySelector('video');
        if (video) {
          video.play();
        }
      }
    }

    function pauseAllVideos() {
      // Pause all videos in the gallery
      var allVideos = document.querySelectorAll('.product .product__media-item .media video');
      allVideos.forEach(function(video) {
        video.pause();
      });
    }

    // Event listener for changes in the swiper
    var swiperContainer = document.querySelector('.product__media-container');
    if (swiperContainer) {
      swiperContainer.addEventListener('transitionend', function() {
        pauseAllVideos();
        playVideoInActiveSlide();
      });
    }

    // Initial check for the active slide video
    playVideoInActiveSlide();
  }
});